import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "./Context.js";
import { useResponsive } from "./Utils.js";
import { RouterModule_nav, RouterModule_urlSegments } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { map, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { contains, tail, head, isEmpty, ofArray, singleton, toArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { append as append_1, head as head_1 } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { createObj, stringHash } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { join } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { empty, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Typography } from "@mui/material";
import Home from "@mui/icons-material/Home";
import Person from "@mui/icons-material/Person";
import PeopleAlt from "@mui/icons-material/PeopleAlt";
import Business from "@mui/icons-material/Business";
import AccountTree from "@mui/icons-material/AccountTree";
import Cached from "@mui/icons-material/Cached";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { View as View_1 } from "./Admin/Dashboard.js";
import { View as View_2 } from "./Admin/Users.js";
import { View as View_3 } from "./Admin/Customers.js";
import { Companies } from "./Admin/Departments.js";
import { CategoriesProvider } from "./Admin/DocumentTreeContexts.js";
import { DocumentTreeAdmin } from "./Admin/DocumentTreeAdmin.js";
import { CustomerPending } from "./Admin/CustomerSync.js";

export function View(viewInputProps) {
    let elems_4;
    const key = viewInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const responsive = useResponsive(undefined);
    const sidebarRef = reactApi.useRef(undefined);
    const currentUrl = RouterModule_urlSegments(window.location.hash, 1);
    const sidebarWidth = defaultArg(map((arg) => ~~arg.clientWidth, sidebarRef.current), 0) | 0;
    const patternInput = defaultArg(map((s) => [s.IsAdmin, s.IsSuperAdmin], ctx.Session), [false, false]);
    const isSuperAdmin = patternInput[1];
    const versionNumber = defaultArg(map((s_1) => s_1.VersionNumber, ctx.Session), "N/A");
    reactApi.useEffect(() => {
        console.debug("[Admin] useEffect url %o", toArray(currentUrl));
        if (!(patternInput[0] ? true : isSuperAdmin)) {
            RouterModule_nav(singleton(""), 1, 1);
        }
        let matchResult;
        if (!isEmpty(currentUrl)) {
            if (head(currentUrl) === "admin") {
                if (isEmpty(tail(currentUrl))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                RouterModule_nav(ofArray(["admin", "dashboard", "coh"]), 1, 1);
                break;
            }
            case 1: {
                break;
            }
        }
    });
    const sidebarNavigateButton = (url, buttonIcon, text) => {
        let elems;
        const selected = contains(head_1(url), currentUrl, {
            Equals: (x, y) => (x === y),
            GetHashCode: stringHash,
        });
        return createElement("div", createObj(ofArray([["title", text], ["className", join(" ", toList(delay(() => append(singleton_1("navigation-button"), delay(() => (selected ? singleton_1("selected") : empty()))))))], ["onClick", (_arg_1) => {
            RouterModule_nav(ofArray(append_1(["admin"], url)), 1, 1);
        }], (elems = [buttonIcon([["sx", {
            width: 24 + "px",
            height: 24 + "px",
        }]]), MuiHelpers_createElement(Typography, [["variant", "h6"], ["noWrap", true], ["children", text]])], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        alignItems: "start",
        columnGap: 30 + "px",
        height: 100 + "%",
    }], (elems_4 = toList(delay(() => {
        let matchValue, elems_2, elems_1;
        return append((matchValue = responsive, (matchValue === "mobileLandscape") ? singleton_1(createElement("div", createObj(ofArray([["id", "admin-sidebar"], ["ref", sidebarRef], ["style", {
            display: "flex",
            flexDirection: "column",
            position: "sticky",
            rowGap: 20 + "px",
            top: 120 + "px",
        }], (elems_2 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", "Administrasjon"]]), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            rowGap: 10 + "px",
        }], (elems_1 = toList(delay(() => append(singleton_1(sidebarNavigateButton(["dashboard", "coh"], (props_3) => {
            const props_5 = createObj(props_3);
            return react.createElement(Home, props_5);
        }, "Dashboard")), delay(() => append(singleton_1(sidebarNavigateButton(["users"], (props_6) => {
            const props_8 = createObj(props_6);
            return react.createElement(Person, props_8);
        }, ctx.Locale.t("Pages.Admin.Users"))), delay(() => append(singleton_1(sidebarNavigateButton(["customer-groups"], (props_9) => {
            const props_11 = createObj(props_9);
            return react.createElement(PeopleAlt, props_11);
        }, ctx.Locale.t("Pages.Admin.Customers"))), delay(() => append(singleton_1(sidebarNavigateButton(["companies"], (props_12) => {
            const props_14 = createObj(props_12);
            return react.createElement(Business, props_14);
        }, ctx.Locale.t("Companies.Companies"))), delay(() => append(isSuperAdmin ? singleton_1(sidebarNavigateButton(["document-categories"], (props_15) => {
            const props_17 = createObj(props_15);
            return react.createElement(AccountTree, props_17);
        }, ctx.Locale.t("Pages.DocumentTreeAdmin"))) : empty(), delay(() => singleton_1(sidebarNavigateButton(["pending"], (props_18) => {
            const props_20 = createObj(props_18);
            return react.createElement(Cached, props_20);
        }, ctx.Locale.t("Pages.VismaSync"))))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : ((matchValue === "tablet") ? singleton_1(createElement("div", createObj(ofArray([["id", "admin-sidebar"], ["ref", sidebarRef], ["style", {
            display: "flex",
            flexDirection: "column",
            position: "sticky",
            rowGap: 20 + "px",
            top: 120 + "px",
        }], (elems_2 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", "Administrasjon"]]), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            rowGap: 10 + "px",
        }], (elems_1 = toList(delay(() => append(singleton_1(sidebarNavigateButton(["dashboard", "coh"], (props_3) => {
            const props_5 = createObj(props_3);
            return react.createElement(Home, props_5);
        }, "Dashboard")), delay(() => append(singleton_1(sidebarNavigateButton(["users"], (props_6) => {
            const props_8 = createObj(props_6);
            return react.createElement(Person, props_8);
        }, ctx.Locale.t("Pages.Admin.Users"))), delay(() => append(singleton_1(sidebarNavigateButton(["customer-groups"], (props_9) => {
            const props_11 = createObj(props_9);
            return react.createElement(PeopleAlt, props_11);
        }, ctx.Locale.t("Pages.Admin.Customers"))), delay(() => append(singleton_1(sidebarNavigateButton(["companies"], (props_12) => {
            const props_14 = createObj(props_12);
            return react.createElement(Business, props_14);
        }, ctx.Locale.t("Companies.Companies"))), delay(() => append(isSuperAdmin ? singleton_1(sidebarNavigateButton(["document-categories"], (props_15) => {
            const props_17 = createObj(props_15);
            return react.createElement(AccountTree, props_17);
        }, ctx.Locale.t("Pages.DocumentTreeAdmin"))) : empty(), delay(() => singleton_1(sidebarNavigateButton(["pending"], (props_18) => {
            const props_20 = createObj(props_18);
            return react.createElement(Cached, props_20);
        }, ctx.Locale.t("Pages.VismaSync"))))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : ((matchValue === "desktop") ? singleton_1(createElement("div", createObj(ofArray([["id", "admin-sidebar"], ["ref", sidebarRef], ["style", {
            display: "flex",
            flexDirection: "column",
            position: "sticky",
            rowGap: 20 + "px",
            top: 120 + "px",
        }], (elems_2 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", "Administrasjon"]]), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            rowGap: 10 + "px",
        }], (elems_1 = toList(delay(() => append(singleton_1(sidebarNavigateButton(["dashboard", "coh"], (props_3) => {
            const props_5 = createObj(props_3);
            return react.createElement(Home, props_5);
        }, "Dashboard")), delay(() => append(singleton_1(sidebarNavigateButton(["users"], (props_6) => {
            const props_8 = createObj(props_6);
            return react.createElement(Person, props_8);
        }, ctx.Locale.t("Pages.Admin.Users"))), delay(() => append(singleton_1(sidebarNavigateButton(["customer-groups"], (props_9) => {
            const props_11 = createObj(props_9);
            return react.createElement(PeopleAlt, props_11);
        }, ctx.Locale.t("Pages.Admin.Customers"))), delay(() => append(singleton_1(sidebarNavigateButton(["companies"], (props_12) => {
            const props_14 = createObj(props_12);
            return react.createElement(Business, props_14);
        }, ctx.Locale.t("Companies.Companies"))), delay(() => append(isSuperAdmin ? singleton_1(sidebarNavigateButton(["document-categories"], (props_15) => {
            const props_17 = createObj(props_15);
            return react.createElement(AccountTree, props_17);
        }, ctx.Locale.t("Pages.DocumentTreeAdmin"))) : empty(), delay(() => singleton_1(sidebarNavigateButton(["pending"], (props_18) => {
            const props_20 = createObj(props_18);
            return react.createElement(Cached, props_20);
        }, ctx.Locale.t("Pages.VismaSync"))))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : ((matchValue === "wideScreen") ? singleton_1(createElement("div", createObj(ofArray([["id", "admin-sidebar"], ["ref", sidebarRef], ["style", {
            display: "flex",
            flexDirection: "column",
            position: "sticky",
            rowGap: 20 + "px",
            top: 120 + "px",
        }], (elems_2 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", "Administrasjon"]]), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            rowGap: 10 + "px",
        }], (elems_1 = toList(delay(() => append(singleton_1(sidebarNavigateButton(["dashboard", "coh"], (props_3) => {
            const props_5 = createObj(props_3);
            return react.createElement(Home, props_5);
        }, "Dashboard")), delay(() => append(singleton_1(sidebarNavigateButton(["users"], (props_6) => {
            const props_8 = createObj(props_6);
            return react.createElement(Person, props_8);
        }, ctx.Locale.t("Pages.Admin.Users"))), delay(() => append(singleton_1(sidebarNavigateButton(["customer-groups"], (props_9) => {
            const props_11 = createObj(props_9);
            return react.createElement(PeopleAlt, props_11);
        }, ctx.Locale.t("Pages.Admin.Customers"))), delay(() => append(singleton_1(sidebarNavigateButton(["companies"], (props_12) => {
            const props_14 = createObj(props_12);
            return react.createElement(Business, props_14);
        }, ctx.Locale.t("Companies.Companies"))), delay(() => append(isSuperAdmin ? singleton_1(sidebarNavigateButton(["document-categories"], (props_15) => {
            const props_17 = createObj(props_15);
            return react.createElement(AccountTree, props_17);
        }, ctx.Locale.t("Pages.DocumentTreeAdmin"))) : empty(), delay(() => singleton_1(sidebarNavigateButton(["pending"], (props_18) => {
            const props_20 = createObj(props_18);
            return react.createElement(Cached, props_20);
        }, ctx.Locale.t("Pages.VismaSync"))))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : singleton_1(defaultOf()))))), delay(() => {
            let elems_3;
            return singleton_1(createElement("div", createObj(ofArray([["style", {
                height: 100 + "%",
                flexGrow: 1,
                flexShrink: 1,
                minWidth: 600 + "px",
            }], (elems_3 = toList(delay(() => (!isEmpty(currentUrl) ? ((head(currentUrl) === "admin") ? (!isEmpty(tail(currentUrl)) ? ((head(tail(currentUrl)) === "dashboard") ? singleton_1(createElement(View_1, null)) : ((head(tail(currentUrl)) === "users") ? (isEmpty(tail(tail(currentUrl))) ? singleton_1(createElement(View_2, null)) : singleton_1(createElement("p", {
                children: ["404"],
            }))) : ((head(tail(currentUrl)) === "customer-groups") ? singleton_1(createElement(View_3, null)) : ((head(tail(currentUrl)) === "companies") ? (isEmpty(tail(tail(currentUrl))) ? singleton_1(createElement(Companies, null)) : singleton_1(createElement("p", {
                children: ["404"],
            }))) : ((head(tail(currentUrl)) === "document-categories") ? (isEmpty(tail(tail(currentUrl))) ? singleton_1(createElement(CategoriesProvider, {
                children: [createElement(DocumentTreeAdmin, {
                    key: "document-tree-admin",
                    $key: "document-tree-admin",
                })],
            })) : singleton_1(createElement("p", {
                children: ["404"],
            }))) : ((head(tail(currentUrl)) === "pending") ? (isEmpty(tail(tail(currentUrl))) ? singleton_1(createElement(CustomerPending, null)) : singleton_1(createElement("p", {
                children: ["404"],
            }))) : singleton_1(createElement("p", {
                children: ["404"],
            })))))))) : singleton_1(createElement("p", {
                children: ["404"],
            }))) : singleton_1(createElement("p", {
                children: ["404"],
            }))) : singleton_1(createElement("p", {
                children: ["404"],
            }))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

export default ((key) => createElement(View, {
    key: key,
    $key: key,
}));

